import React, { FC } from 'react';

import { BUTTON_TYPES, EvConfirm } from '@evinced-private/ui-common';

import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';
import { Logger } from 'src/common/services/Logger';

interface IDeleteSessionConfirmationPopup {
	onConfirm: () => Promise<void>;
}

export const DeleteSessionConfirmationPopup: FC<IDeleteSessionConfirmationPopup> = ({
	onConfirm
}: IDeleteSessionConfirmationPopup) => {
	const onConfirmDelete = async (closeModal: () => void): Promise<void> => {
		try {
			await onConfirm();
			closeModal();
		} catch (error) {
			// Swallow the rejection so this promise still resolves. EvConfirm leaves
			// its loading state only after onConfirm settles, and the modal stays
			// open so the user can retry.
			Logger.error('Failed to confirm session deletion', { error });
		}
	};

	return (
		<EvConfirm
			appElement={PLATFORM_APP_ID}
			title="Confirm Delete"
			approveButtonText="Delete Session"
			onConfirm={onConfirmDelete}
			promptMessage="Are you sure you want to delete this session?"
			triggerButtonProps={{
				type: BUTTON_TYPES.SECONDARY,
				title: 'Delete',
				children: 'Delete'
			}}
		/>
	);
};
